export default __webpack_public_path__ + "static/B0072-b31237d13ac3ded783952121e081d55f.png";